import React from "react";
import { Button, Modal } from "antd";
import { updateCommentContact } from "../../Libs/api";
import { toast } from "react-toastify";

const ViewContact = ({ singleData, openModal, onClose }) => {
  const [comment, setComment] = React.useState(singleData?.comment || "");

  const [loading, setLoading] = React.useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let formData = {
      comment: comment,
      id: singleData?.id,
    };

    try {
      const apiCall = await updateCommentContact(formData);
      if (apiCall.status) {
        console.log(apiCall, "apiCall");

        setLoading(false);
        toast.success("Record Updated Successfully!");
        onClose();
      } else {
        setLoading(false);

        toast.error(apiCall?.message);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(error);
    }
  };
  return (
    <Modal
      title={
        <div
          style={{
            background: "#006666",
            color: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          View Contact Details
        </div>
      }
      centered
      open={openModal}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={[
        <Button
          key="ok"
          type="primary"
          style={{ background: "#006666", color: "white" }}
          onClick={(e) => {
            handleSubmit(e);
          }}
          disabled={loading}
        >
          OK
        </Button>,
      ]}
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Name.."
                    value={singleData?.name}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Email.."
                    value={singleData?.email}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Phone No</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Phone No.."
                    value={singleData?.phoneNo}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Subject</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Subject.."
                    value={singleData?.subject}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="mb-3">
                  <label class="form-label">Message</label>
                  <input
                    class={`form-control `}
                    type="textarea"
                    placeholder="Enter Message.."
                    value={singleData?.message}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="mb-3">
                  <label class="form-label">Comment</label>
                  <input
                    class={`form-control `}
                    type="textarea"
                    placeholder="Enter Comment.."
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewContact;
